module.exports = __webpack_public_path__ + "static/media/preparation.e77f692c.svg";